import type { JSX } from 'react';
import { makeStyles } from '@mui/styles';
import { APP_HEIGHT } from '@/constants/layout';
import LoadingAnimation from '../../components/Animations/LoadingAnimation';
import CustomTypography from '../../components/Common/Typography';

const useStyles = makeStyles(({
  page: {
    height: APP_HEIGHT,
    width: '100vw',
  },
}));

interface ILoadingPageProps {
  message?: string;
}

export function LoadingPage({
  message,
}: ILoadingPageProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.page}>
      <LoadingAnimation
        msg={(
          <CustomTypography variant="bodyRegular">
            {message}
          </CustomTypography>
        )}
      />
    </div>
  );
}
